module.exports = __webpack_public_path__ + "d8bc76a2d6c03d44b0fe91c22569fe8d.png";